<template>
  <div class="page-wraper">
    <div class="main">
      <div class="tab-box">
        <div
          class="class-room-detail bottomStyle"
          :class="type == 1 ? 'active' : ''"
          @click="type = 1"
        >
          <span class="button-content">
            <img v-if="type == 1" src="/image/detail.png" />
            <img v-else src="/image/detail-r.png" />
            <span>教室详情</span>
          </span>
        </div>
        <div
          class="class-room-map bottomStyle"
          :class="type == 2 ? 'active' : ''"
          @click="type = 2"
        >
          <span class="button-content">
            <img v-if="type == 1" src="/image/pingmiantu.png" />
            <img v-else src="/image/pingmiantu-r.png" />
            <span>教室平面图</span>
          </span>
        </div>
      </div>
      <div v-if="type == 1">
        <div class="class-room-log">
          <div class="listItem yellow-border">
            <div class="title">{{ detail.Name }}</div>
            <p>{{ detail.RoomParameters }}</p>
          </div>
        </div>
        <Calender
          :defauleMonth="currentMonth"
          :hasShowStar="hasItems"
          :switchMonthCallback="onCalenderSwitchMonth"
          @dateSelect="onDateSelect"
          style="margin-bottom: 10px"
        />

        <div
          v-if="currentMonth == currentSelectDateInfo.Month"
          class="bottomList"
        >
          <div
            class="listItem"
            v-for="(item, index) in currentSelectDateInfo.Items"
            :key="index"
            :class="index % 2 == 0 ? 'yellow-border' : 'red-border'"
          >
            <p>课程名称：{{ item.CourseName }}</p>
            <p>上课时间：{{ item.BeginTime }} - {{ item.EndTime }}</p>
            <p>预订人：{{ item.TeacherName }}</p>
            <p>班次名称：{{ item.ClassName }}</p>
            <img v-if="item.DisplayConfirmFlag" src="../../../public/image/review.png" alt="" class="review">
          </div>
        </div>
      </div>
      <div v-else>
        <div class="img-view-wraper">
          <ImageView
            v-if="detail.RoomMapImageUrl"
            :src="detail.RoomMapImageUrl"
          >
          </ImageView>
          <van-empty v-else description="未上传图片" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import classRoomApi from "@/api/classRoom";
import moment from "moment";
import Calender from "../components/Calender";
import ImageView from "@/components/tools/ImageView";

export default {
  components: {
    Calender,
    ImageView
  },
  data() {
    return {
      type: 1,
      currentMonth: moment().format("YYYY-MM"),
      detail: {},
      roomSchedulesByDate: {},
      currentSelectDateInfo: {
        Items: []
      }
    };
  },
  created() {
    const query = this.$route.query;
    const that = this;
    this.fetchMeetingRoomApplies(query, () => {
      that.onDateSelect(moment().format("YYYY-MM-DD"));
    });
  },
  methods: {
    hasItems(day) {
      const { roomSchedulesByDate } = this;
      const date = moment(day.date).format("YYYY-MM-DD");
      if (roomSchedulesByDate[date] && roomSchedulesByDate[date].Items.length) {
        return true;
      }
      return false;
    },
    fetchMeetingRoomApplies(param, callback = null) {
      const { currentMonth } = this;
      const json = {
        ...param,
        BeginDate: moment(currentMonth)
          .startOf("month")
          .format("YYYY-MM-DD"),
        EndDate: moment(currentMonth)
          .endOf("month")
          .format("YYYY-MM-DD"),
        FilterAccess: true
      };
      classRoomApi.QueryMeetingRoomApplies(json).then(res => {
        if (res.Data.length) {
          const detail = res.Data[0];
          let roomSchedulesByDate = {};
          for (let i = 0; i < detail.Schedules.length; i++) {
            const item = detail.Schedules[i];
            roomSchedulesByDate[item.Date] = item;
          }
          this.roomSchedulesByDate = roomSchedulesByDate;
          this.detail = detail;
          if (callback) {
            callback(res);
          }
        }
      });
    },
    onCalenderSwitchMonth(date) {
      this.currentMonth = date.format("YYYY-MM");
      return new Promise(resolve => {
        this.fetchMeetingRoomApplies(this.$route.query, res => {
          resolve(res);
        });
      });
    },
    onDateSelect(date) {
      const { roomSchedulesByDate } = this;
      const item = roomSchedulesByDate[date];
      item.Month = moment(date).format("YYYY-MM");
      this.currentSelectDateInfo = item;
    }
  }
};
</script>

<style lang="less" scoped>
.main {
  padding: 7px 15px;
  width: 100%;
  .tab-box {
    width: 100%;
    display: flex;
    border-radius: 4px;
    margin-bottom: 10px;
    .bottomStyle {
      flex: 1;
      line-height: 40px;
      height: 40px;
      text-align: center;
      border-radius: 4px;
      background: rgb(248, 248, 248);
      .button-content {
        display: inline-flex;
        align-items: center;
      }
      img {
        width: 18px;
        margin-right: 5px;
      }
    }
    .active {
      background-color: rgb(210, 0, 0);
      color: #fff;
    }
  }
  .title {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 15px;
  }
  .listItem {
    padding: 15px;
    background-color: rgb(248, 248, 248);
    font-size: 14px;
    color: rgb(51, 51, 51);
    margin-bottom: 10px;
    border-radius: 5px;
    letter-spacing: 0px;
    position: relative;
    .review{
      height: 60px;
      position: absolute;
      right: 0;
      bottom: 0;
    }
  }
  .yellow-border {
    border-top: 2px solid rgb(255, 198, 58);
  }
  .red-border {
    border-top: 2px solid rgb(210, 0, 0);
  }
  p {
    margin-bottom: 2px;
  }
  p :last-child {
    margin-bottom: 0px;
  }
}
/deep/.image-wraper {
  height: calc(100vh - 190px);
  .image-wiew img {
    width: calc(100vh - 190px);
    // height: calc(100vw - 40px);

    margin-left: -100px;
    margin-top: -10px;
  }
}
</style>
